import { render, staticRenderFns } from "./video-viewer.vue?vue&type=template&id=5d6489e9&scoped=true"
import script from "./video-viewer.vue?vue&type=script&lang=js"
export * from "./video-viewer.vue?vue&type=script&lang=js"
import style0 from "./video-viewer.vue?vue&type=style&index=0&id=5d6489e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6489e9",
  null
  
)

export default component.exports